import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    borderRadius: '20px 20px 0px 0px',
    height: '100vh',
    BoxShadow: 'none'
  },
  selectBoxes: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // borderRadius: '40px 40px 0px 0px',
    width: '100%'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  fullWidth: {
    width: '100%'
  },
  oneBoxInRow: {
    paddingLeft: 10,
    paddingRight: 15,
    width: '100%',
    paddingBottom: 30,
    position: 'absolute',
    bottom: 0,
    top: 0,
    // height: 650,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowX: 'hidden',
    justifyContent: 'space-between',
    '& div': {
      '& label': {
        paddingLeft: 0
      }
    }
  },
  buttonOfDate: {
    width: 282,
    height: 50,
    textAlign: 'left',
    '& span': {
      margin: '12px 0px',
      fontSize: 14
    }
  },
  dateRangePicker: {
    position: 'absolute',
    right: -2,
    top: -8,
    zIndex: 1
  },
  textShowOnButtonParrent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  textShowOnButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginLeft: -48
  },
  typographyOfButton: {
    color: `${theme.palette.grey[200]} !important`
  },
  typographyOfButtonAfterSelectDate: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 12,
    fontWeight: 500
  },
  typographyOfButtonAfterSelectDateForArrivalDateAndDeparture: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 13,
    fontWeight: 700
  },

  ButtonsContainer: {
    borderRadius: '20px 20px 0px 0px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '110%',
    paddingTop: 30,
    paddingBottom: 20,
    marginBottom: 20,
    height: 50,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    marginLeft: -20,
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.grey[100],
    zIndex: 9999,
    '& Button:first-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[700]}`,
      paddingBottom: 35
    },
    '& Button:last-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.primary.main}`,
      paddingBottom: 35
    }
  },
  ButtonsContainerForPrimaryFilter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '110%',
    marginTop: 20,
    marginBottom: 20,
    height: 50,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    marginLeft: -10,
    '& Button:first-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[700]}`
    },
    '& Button:last-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.primary.main}`
    }
  },
  typographyOfTitle: {
    paddingBottom: 10
  },
  typographyOfTitleForPrimaryFilter: {
    paddingBottom: 10,
    marginLeft: 10
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 15,
    marginBottom: 15
  },
  buttonContainer: {
    width: '100%'
  },
  hideZerosFromPriceContainer: {
    display: 'flex',
    alignItems: 'center'
  }
}))

export default useStyles
